import styled from 'styled-components'

const BackgroundDiv = styled.div`
  background-image: url(${props=> props.url})
`
export default BackgroundDiv